module.exports = __webpack_public_path__ + "img/tjrk.4197a2fc.png";